module.exports = __webpack_public_path__ + "static/hexospark-logo-d588f4a7cb05f0f748575d969da81c99.svg";